import { render, staticRenderFns } from "./credithour.vue?vue&type=template&id=34027ae6&scoped=true&"
import script from "./credithour.vue?vue&type=script&lang=js&"
export * from "./credithour.vue?vue&type=script&lang=js&"
import style0 from "./credithour.vue?vue&type=style&index=0&id=34027ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34027ae6",
  null
  
)

export default component.exports